export const FileTranslationsProcessingStatus = {
  //Upload Processing
  UPLOAD_IN_PROGRESS: 'upload-in-progress' as const,
  UPLOAD_ERROR: 'upload-error' as const,
  PROCESSING: 'processing' as const,

  //Translating Processing
  TRANSLATING: 'translating' as const,
  TRANSLATING_ERROR: 'translating-error' as const,
  TRANSLATED: 'translated' as const,
};
